<template>
  <div class="container">
    <div class="bg" @click="knowMore"></div>
    <div class="steps">
      <p>
        工作室是{{ userTxt }}与其他志趣相投的{{
          userTxt
        }}或玩家形成自己的组织的一种方式，创建或者加入工作室，与更多志同道合的人一起玩！还可以获得工作室专属权益。
      </p>
      <span class="applyTitle">申请条件</span>
      <div class="step-wrap">
        <div class="step">
          <div class="icon icon-time"></div>
          <p>注册时间>7天</p>
        </div>
        <div class="step">
          <div class="icon icon-products"></div>
          <p>公开作品数>3个</p>
        </div>
        <div class="step">
          <div class="icon icon-developer"></div>
          <p>已成为认证{{ userTxt }}</p>
        </div>
      </div>
    </div>
    <el-button
      type="primary"
      @click="handleBtnClick"
      :class="{ disabled: cannotApply }"
      :disabled="isAppling"
      >{{ btnText }}</el-button
    >
  </div>
</template>

<script>
import { checkStudioRegisterStatus } from '@/api/studio';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      is_developer_limit: 0,
      is_day_limit: 0,
      is_artist_limit: 0,
      isAppling: false,
      btnText: '创建工作室',
      userTxt: '开发者',
      newAble: false,
    };
  },
  mounted() {
    console.log('mounted');
    checkStudioRegisterStatus({ json: 1 }).then(res => {
      let { data } = res;
      this.is_developer_limit = data.is_developer_limit;
      this.is_day_limit = data.is_day_limit;
      this.is_artist_limit = data.is_artist_limit;
      this.isAppling = data.is_in_approve;
      if (this.isAppling) {
        this.btnText = '注册审核中';
      }
    });
    //判断是否是427灰度测试
    let version = '';
    //判断是否是427版本
    if (this.userInfo.ver) {
      let ver = this.userInfo.ver.split('.');
      version =
        (parseInt(ver[0]) << 16) + (parseInt(ver[1]) << 8) + parseInt(ver[2]);
      if (version >= 68608) {
        this.userTxt = '开发者';
        this.newAble = false;
      } else {
        this.userTxt = '开发者';
        this.newAble = false;
      }
    }
  },
  computed: {
    cannotApply: function () {
      return !(
        this.is_developer_limit &&
        this.is_day_limit &&
        this.is_artist_limit
      );
    },
    ...mapState(['developerInfo', 'userInfo']),
  },
  methods: {
    handleBtnClick() {
      //创建工作室点击埋点
      this.$log('create_studio_click', 85440, { v7: 1 });
      if (this.cannotApply) {
        if (!this.is_day_limit) {
          this.$message.error('您当前注册天数少于7天哦~');
        } else if (!this.is_artist_limit) {
          this.$message.error('公开作品数不得少于3个');
        } else {
          if (this.newAble) this.$message.error('请先注册成为创作者');
          else this.$message.error('请先注册成为开发者');
        }
      } else {
        this.$router.push({ name: 'creatorForm' });
      }
    },
    knowMore() {
      window.open('https://dev-wiki.mini1.cn/wiki/695.html?id=695', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.bg {
  width: 100%;
  height: 160px;
  background: url('../../../assets/images/creatorBg.png') 0 0 no-repeat;
  background-size: 1056px 160px;
  cursor: pointer;
}
.steps {
  padding: 100px 77px 27px;
  text-align: center;
  p {
    font-size: 16px;
    line-height: 26px;
    text-align: center;
  }
  .applyTitle {
    display: inline-block;
    padding: 0 36px;
    position: relative;
    font-size: 20px;
    line-height: 26px;
    color: #323232;
    margin: 63px auto 21px;
    &::before,
    &::after {
      display: block;
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 24px;
      height: 10px;
      background: url('../../../assets/images/title_fix.svg') 0 0 no-repeat;
      background-size: 24px 10px;
    }
    &::before {
      left: 0;
    }
    &::after {
      right: 0;
      transform: rotate(180deg);
    }
  }
  .step-wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 142px;
    .step {
      width: 236px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      .icon {
        width: 120px;
        height: 120px;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: 120px;
        &.icon-time {
          background-image: url('../../../assets/images/icon-time.svg');
        }
        &.icon-products {
          background-image: url('../../../assets/images/icon-products.svg');
        }
        &.icon-developer {
          background-image: url('../../../assets/images/icon-developer.svg');
        }
      }
      p {
        margin-top: 15px;
        color: #81818f;
        font-size: 16px;
        line-height: 21px;
      }
    }
  }
}
.el-button {
  display: block;
  width: 200px;
  height: 50px;
  margin: 0 auto 60px;
  font-size: 20px;
  &.disabled {
    opacity: 0.6;
  }
}
</style>
